export default __webpack_public_path__ + "static/media/solarmw.10f069d9.png";